import instance from '../axios';

export const getAll = async () => {
  const response = await instance.get(`banks`);
  return response.data;
};
export const insert = async (data) => {
  const response = await instance.post(`banks`, data);
  return response;
};
export const update = async (data) => {
  const response = await instance.put(`banks`, data);
  return response;
};
export const remove = async (id) => {
  const response = await instance.delete(`banks/` + id);
  return response;
};

export const transfer = async (data) => {
  const response = await instance.post(`banks/transfer`, data);
  return response;
};

export const passwordValidation = async (data) => {
  const response = await instance.post(`banks/password`, data);
  return response;
};
